import { getContext } from 'svelte';
import type { CheckoutContext } from '../../types';
import { Contexts } from '#lib/constants/contexts.js';
import type { EditionsRoutes } from '#lib/websites/editions/constants/routes.js';

export const getCheckoutContext = () => {
	return getContext<CheckoutContext<EditionsRoutes>>(Contexts.Checkout);
};
